module.exports = __webpack_public_path__ + "static/media/Profile_1.ae010775.svg";